import {useContext, useState} from "react";
import userContext from "../../store/userContext";
import Button from "../../components/ui/Button";
import {Link} from "react-router-dom";
import magazineArchive from "../../store/magazineArchive";
import BookOpenIconFontAwesome from "../../svg/fontawesome/BookOpenIconFontAwesome";

export default function MagazineArchivePage() {
	window.title = "Magasinarkiv | Båtens Verden";

	const user = useContext(userContext);
	const [searchTerm, setSearchTerm] = useState("");
	const [yearFilter, setYearFilter] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 12;

	const magazineData = magazineArchive;

	// Unike årstall for filtrering
	const uniqueYears = Array.from(new Set(magazineData.map(mag => mag.year))).sort((a, b) => b - a);

	// Filtrerte magasiner
	const filteredMagazines = magazineData.filter(magazine => {
		const matchesSearch = searchTerm === "" ||
			magazine.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
			magazine.description.toLowerCase().includes(searchTerm.toLowerCase());

		const matchesYear = yearFilter === "" || magazine.year.toString() === yearFilter;

		return matchesSearch && matchesYear;
	});

	// Paginering
	const totalPages = Math.ceil(filteredMagazines.length / itemsPerPage);
	const currentMagazines = filteredMagazines.slice(
		(currentPage - 1) * itemsPerPage,
		currentPage * itemsPerPage
	);

	const hasBåtforbundetMembership = true

	return (
		<div>
			<main className="container mx-auto px-4 py-8 max-w-6xl">
				<div className="mb-8">
					<h1 className="text-3xl font-bold text-primary mb-2">Båtens Verden Magasinarkiv</h1>

					<div className="bg-green-50 border border-solid border-green-200 rounded-lg p-4 flex flex-col gap-3 mt-3">
						<div className="flex items-center gap-3">
							<BookOpenIconFontAwesome className="h-5 w-5 ml-1 text-primary flex-shrink-0"/>
							<div>
								<p className="font-medium text-primary">Begrenset tilgang til magasinarkivet</p>
								<p className="text-sm text-muted-foreground">
									Som Båtforbundet-medlem har du tilgang til 3 utgaver årlig av Båtens Verden
								</p>
							</div>
						</div>

						<div className="p-4 rounded-lg mt-2 bg-blue-300/10">
							<div
								className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
								<div className="flex flex-col gap-1">
									<h3 className="font-semibold text-primary">Oppgrader til fullt abonnement</h3>
									<p className="text-gray-600 text-sm text-muted-foreground">
										Med fullt abonnement får du alle 6 utgaver hjem på døra
									</p>
									<p className="text-sm font-medium mt-1">
										Som medlem av Båtforbundet (KNBF) får du <span
										className="text-blue-500">spesialpris</span>.
									</p>
								</div>
								<Link to={'https://abo.b-v.no/knbf/'} target={'_blank'}><Button className="mt-3">Se tilbud</Button></Link>
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-col md:flex-row gap-4 mb-6">
					{/*<div className="relative flex-grow">
						<button className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground"></button>
						<input
							type="search"
							placeholder="Søk i magasinarkivet..."
							className="pl-9"
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>*/}

					<div className="w-full md:w-48 flex flex-grow items-center gap-2">
						<div className={'w-fit'}>Filtrer på år</div>
						<select style={{fontFamily:'var(--font1)'}} className="flex h-10 items-center justify-between rounded-md border border-input px-3 py-2 text-sm bg-white cursor-pointer"
							value={yearFilter} onChange={(ev) => {
							setYearFilter(ev.currentTarget.value)
						}}>
							<option value="">Alle år</option>
							{uniqueYears.map(year => (
								<option key={year} value={year.toString()}>
									{year}
								</option>
							))}
						</select>
					</div>
				</div>

				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-6">
					{currentMagazines.map((magazine) => (
						<Link to={magazine.id} key={magazine.id} className="flex flex-col h-full bg-white p-2 rounded-lg border border-solid border-gray-200
						 hover:hover:bg-gray-200 hover:border-gray-300 hover:shadow-md transition-all duration-100">
							<div className="pb-0">
								<div className="aspect-[210/297] relative mb-2 bg-slate-100 rounded overflow-hidden">
									<img
										src={magazine.coverImage}
										alt={`Forside ${magazine.issueNumber}`}
										className="absolute inset-0 w-full h-full object-cover"
										loading={"lazy"}
									/>

									<div className="absolute top-2 right-2">
										<div variant="secondary" className="bg-white font-mono text-xs p-1">
											{magazine.issueNumber}
										</div>
									</div>
								</div>
							</div>

							<div className="pb-0 flex-grow ml-2">
								<p className="text-sm text-muted-foreground flex items-center gap-1 mt-1 capitalize">
									{magazine.month + ' ' + magazine.year}
								</p>
							</div>

							<div className="pt-2">
								<Link to={magazine.id}><Button
									className="w-full flex items-center gap-2"
									variant={hasBåtforbundetMembership ? "default" : "secondary"}
									disabled={!hasBåtforbundetMembership}
								>
									<span>{hasBåtforbundetMembership ? "Vis" : "Krever medlemskap"}</span>
								</Button></Link>
							</div>
						</Link>
					))}
				</div>

				{/* Paginering */}
				{totalPages > 1 && (
					<div className="flex justify-center items-center gap-2 mt-6">
						<Button
							variant="outline"
							size="icon"
							onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
							disabled={currentPage === 1}
						>
							{"<"}
						</Button>

						<span className="text-sm">
              Side {currentPage} av {totalPages}
            </span>

						<Button
							variant="outline"
							size="icon"
							onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
							disabled={currentPage === totalPages}
						>
							{">"}
						</Button>
					</div>
				)}
			</main>
		</div>
	);
}